import { ReactComponent as CopySvg } from "../../assets/icons/copy-white.svg";
import { useLockBodyScroll } from "../../hooks/useLockBodyScroll";
import Modal from "../utils/Modal/Modal";
import {
  ModalContainer,
  CloseButton,
  ModalContent,
  ModalTitle,
  Row,
  Label,
  PromptCard,
  ButtonGroup,
  ConfirmButton,
} from "./CollectionSettingsModal.styles";

const CollectionSettingsModal = ({
  isOpen,
  onClose,
  onCopy,
  settingsPrompt,
}) => {
  useLockBodyScroll(isOpen);

  const handleCopy = () => {
    onCopy();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      customOverlayStyles={{ zIndex: 3100 }}
    >
      <ModalContainer>
        <ModalContent>
          {/* Header — title + copy (click copies + closes, as before) */}
          <Row>
            <ModalTitle>Prompt</ModalTitle>
            <CloseButton onClick={handleCopy} aria-label="Copy prompt">
              <CopySvg width={18} height={18} />
            </CloseButton>
          </Row>

          {/* Prompt body inside a scrollable frosted card */}
          <PromptCard>
            <Label>{settingsPrompt}</Label>
          </PromptCard>

          {/* Primary CTA — same handler as the header copy icon */}
          <ButtonGroup>
            <ConfirmButton onClick={handleCopy}>
              <CopySvg width={16} height={16} />
              Copy Prompt
            </ConfirmButton>
          </ButtonGroup>
        </ModalContent>
      </ModalContainer>
    </Modal>
  );
};

export default CollectionSettingsModal;
